
/* injects from baggage-loader */

/**
 * @license Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or http://ckeditor.com/license
 */

(function () {
  function addCombo(editor, comboName, styleType, lang, entries, defaultLabel, styleDefinition, order) {
    var config = editor.config;
    var style = new CKEDITOR.style(styleDefinition);
    var styles = {};

    editor.ui.addRichCombo(comboName, {
      label: lang.label,
      title: lang.panelTitle,
      toolbar: 'styles,' + order,
      allowedContent: style,
      requiredContent: style,

      panel: {
        css: [CKEDITOR.skin.getPath('editor')].concat(config.contentsCss),
        multiSelect: false,
        attributes: {'aria-label': lang.panelTitle}
      },

      buildList: function () {
        var rebuildList = CKEDITOR.tools.bind(buildList, this);
        rebuildList();
      },

      sizes: [],

      init: function () {
        var rebuildList = CKEDITOR.tools.bind(buildList, this);
        $(editor).bind('rebuildList', rebuildList);
        this.buildList();
        this.startGroup(lang.panelTitle);
      },

      reBuildStyles: function () {
        styles = {};
        for (var i = 0; i < fonts.length; i++) {
          var name = fonts[i].family;
          var vars = {};
          vars["family"] = name;
          styles[name] = new CKEDITOR.style(styleDefinition, vars);
          styles[name]._.definition.name = name;
        }
      },

      setWeights: function (value) {
        var fontfind = _.filter(fonts, {family: value});
        if (fontfind[0].variants.length === 0) {
          this.sizes = ["regular"];
        } else {
          this.sizes = fontfind[0].variants;
        }
        editor.ui.instances.fontweight.buildListFontWeight()
      },

      onClick: function (value) {

        // Create style objects for all fonts.
        this.setWeights(value);
        editor.ui.instances.fontweight.onClick(this.sizes[0]);
        editor.focus();
        editor.fire('saveSnapshot');

        var previousValue = this.getValue();
        var style = styles[value];

        // When applying one style over another, first remove the previous one (#12403).
        // NOTE: This is only a temporary fix. It will be moved to the styles system (#12687).
        if (previousValue && value !== previousValue) {
          var previousStyle = styles[previousValue];
          var range = editor.getSelection().getRanges()[0];

          // If the range is collapsed we can't simply use the editor.removeStyle method
          // because it will remove the entire element and we want to split it instead.
          if (range.collapsed) {
            var path = editor.elementPath(),
              // Find the style element.
              matching = path.contains(function (el) {
                return previousStyle.checkElementRemovable(el);
              });

            if (matching) {
              var startBoundary = range.checkBoundaryOfElement(matching, CKEDITOR.START);
              var endBoundary = range.checkBoundaryOfElement(matching, CKEDITOR.END);
              var node;
              var bm;

              // If we are at both boundaries it means that the element is empty.
              // Remove it but in a way that we won't lose other empty inline elements inside it.
              // Example: <p>x<span style="font-size:48px"><em>[]</em></span>x</p>
              // Result: <p>x<em>[]</em>x</p>
              if (startBoundary && endBoundary) {
                bm = range.createBookmark();
                // Replace the element with its children (TODO element.replaceWithChildren).
                while (( node = matching.getFirst() )) {
                  node.insertBefore(matching);
                }
                matching.remove();
                range.moveToBookmark(bm);

                // If we are at the boundary of the style element, just move out.
              } else if (startBoundary) {
                range.moveToPosition(matching, CKEDITOR.POSITION_BEFORE_START);
              } else if (endBoundary) {
                range.moveToPosition(matching, CKEDITOR.POSITION_AFTER_END);
              } else {
                // Split the element and clone the elements that were in the path
                // (between the startContainer and the matching element)
                // into the new place.
                range.splitElement(matching);
                range.moveToPosition(matching, CKEDITOR.POSITION_AFTER_END);
                cloneSubtreeIntoRange(range, path.elements.slice(), matching);
              }

              editor.getSelection().selectRanges([range]);
            }
          } else if (typeof previousStyle !== 'undefined') {
            editor.removeStyle(previousStyle);
          }
        }

        editor[previousValue === value ? 'removeStyle' : 'applyStyle'](style);
        editor.fire('saveSnapshot');
      },

      onRender: function () {
        var self = this;
        this.buildList();
        editor.on('selectionChange', function (ev) {
          var currentValue = this.getValue();

          var elementPath = ev.data.path,
            elements = elementPath.elements;

          // For each element into the elements path.
          for (var i = 0, element; i < elements.length; i++) {
            element = elements[i];

            // Check if the element is removable by any of
            // the styles.

            for (var value in styles) {
              if (styles[value].checkElementMatch(element, true, editor)) {
                if (value != currentValue) {
                  this.setValue(value);
                  self.setWeights(value)
                }
                return;
              }
            }
          }

          // If no styles match, just empty it.

          if (window.Editor.mode == "email.page.editor") {
            this.setValue('', defaultLabel);
          } else {
            var globalFont = $(".str-wrapper").css('fontFamily').replace(new RegExp('"', 'g'), "")
            this.setValue(globalFont)
          }

        }, this);
      },

      refresh: function () {
        if (!editor.activeFilter.check(style)) {
          this.setState(CKEDITOR.TRISTATE_DISABLED);
        }
      }
    });
  }

  // Clones the subtree between subtreeStart (exclusive) and the
  // leaf (inclusive) and inserts it into the range.
  //
  // @param range
  // @param {CKEDITOR.dom.element[]} elements Elements path in the standard order: leaf -> root.
  // @param {CKEDITOR.dom.element/null} substreeStart The start of the subtree.
  // If null, then the leaf belongs to the subtree.
  function cloneSubtreeIntoRange(range, elements, subtreeStart) {
    var current = elements.pop();
    if (!current) {
      return;
    }
    // Rewind the elements array up to the subtreeStart and then start the real cloning.
    if (subtreeStart) {
      return cloneSubtreeIntoRange(range, elements, current.equals(subtreeStart) ? null : subtreeStart);
    }

    var clone = current.clone();
    range.insertNode(clone);
    range.moveToPosition(clone, CKEDITOR.POSITION_AFTER_START);

    cloneSubtreeIntoRange(range, elements);
  }

  CKEDITOR.plugins.add('fontfamily', {
    requires: 'richcombo',
    // jscs:disable maximumLineLength
    lang: 'af,ar,bg,bn,bs,ca,cs,cy,da,de,el,en,en-au,en-ca,en-gb,eo,es,et,eu,fa,fi,fo,fr,fr-ca,gl,gu,he,hi,hr,hu,id,is,it,ja,ka,km,ko,ku,lt,lv,mk,mn,ms,nb,nl,no,pl,pt,pt-br,ro,ru,si,sk,sl,sq,sr,sr-latn,sv,th,tr,tt,ug,uk,vi,zh,zh-cn', // %REMOVE_LINE_CORE%
    // jscs:enable maximumLineLength
    init: function (editor) {
      var config = editor.config;
      addCombo(editor, 'FontFamily', 'family', editor.lang.fontfamily, config.font_names, config.font_defaultLabel, config.font_style, 30);
    }
  });
})();

/**
 * The list of fonts names to be displayed in the Font combo in the toolbar.
 * Entries are separated by semi-colons (`';'`), while it's possible to have more
 * than one font for each entry, in the HTML way (separated by comma).
 *
 * A display name may be optionally defined by prefixing the entries with the
 * name and the slash character. For example, `'Arial/Arial, Helvetica, sans-serif'`
 * will be displayed as `'Arial'` in the list, but will be outputted as
 * `'Arial, Helvetica, sans-serif'`.
 *
 *    config.font_names =
 *      'Arial/Arial, Helvetica, sans-serif;' +
 *      'Times New Roman/Times New Roman, Times, serif;' +
 *      'Verdana';
 *
 *    config.font_names = 'Arial;Times New Roman;Verdana';
 *
 * @cfg {String} [font_names=see source]
 * @member CKEDITOR.config
 */


var buildListHasRunOnce = 0;
var buildList = function () {
  fonts = window.Editor.Instrumentations.fonts.concat(window.Editor.Instrumentations.defaultFonts);
  this.reBuildStyles();

  if (buildListHasRunOnce) {
    // Remove the old unordered list from the dom.
    // This is just to cleanup the old list within the iframe
    if (this._.panel) {
      $(this._.panel._.iframe.$).contents().find(".fontfield").parents(".cke_panel_block").find("ul").remove();
    }
    // reset list
    this._.items = {};
    if (this._.list) {
      this._.list._.items = {};
    }
  }


  for (var i = 0; i < fonts.length; i++) {
    var name = fonts[i].family;
    // Add the tag entry to the panel list.
    if (this._.list) {
      this.add(name, "<span class='fontfield listitem'>" + name + "</span>", name);
    }
  }

  if (buildListHasRunOnce) {
    // Force CKEditor to commit the html it generates through this.add
    if (this._.list) {
      this._.committed = 0; // We have to set to false in order to trigger a complete commit()
      this.commit();
    }
  }
  buildListHasRunOnce = 1;
};


/**
 * The text to be displayed in the Font combo is none of the available values
 * matches the current cursor position or text selection.
 *
 *    // If the default site font is Arial, we may making it more explicit to the end user.
 *    config.font_defaultLabel = 'Arial';
 *
 * @cfg {String} [font_defaultLabel='']
 * @member CKEDITOR.config
 */
// CKEDITOR.config.font_defaultLabel = '';

/**
 * The style definition to be used to apply the font in the text.
 *
 *    // This is actually the default value for it.
 *    config.font_style = {
 *      element:    'span',
 *      styles:     { 'font-family': '#(family)' },
 *      overrides:    [ { element: 'font', attributes: { 'face': null } } ]
 *     };
 *
 * @cfg {Object} [font_style=see example]
 * @member CKEDITOR.config
 */
CKEDITOR.config.font_style = {
  element: 'span',
  styles: {'font-family': '#(family)'},
  overrides: [{
    element: 'font', attributes: {'face': null}
  }]
};



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/plugins/fontfamily/plugin.js